enum BenefitParticipationDecisionDescription {
    NoDecision = 'No decision',
    OptedIn = 'Opted in',
    OptedOut = 'Opted out',
  }
  
  export default BenefitParticipationDecisionDescription
  